<div
  class="flex items-center gap-3 p-2 rounded-xl cursor-pointer bg-transparent text-neutral-content dark:text-dark-neutral-content hover:bg-base-400 dark:hover:bg-dark-base-400 hover:text-base-content dark:hover:text-dark-base-content"
  [routerLink]="menuItem().link"
  routerLinkActive="!bg-base-400 dark:!bg-dark-base-400 !text-base-content dark:!text-dark-base-content menu-active"
  [routerLinkActiveOptions]="{ exact: menuItem().exact ?? false }"
>
  @let icon = menuItem().icon; @if (icon) {
  <app-svg-icon
    [type]="icon"
    class="w-6 h-6 text-base-content dark:text-dark-base-content"
  ></app-svg-icon>
  } @else {
  <div class="w-6"></div>
  }
  <span class="text-[15px]">{{ menuItem().title }}</span>

  @if (menuItem().numberIcon) {
  <div
    class="bg-light-primary p-1 h-6 rounded-full flex items-center justify-center"
  >
    <span class="text-[0.8rem] text-light-white leading-[0]">{{
      menuItem().numberIcon
    }}</span>
  </div>
  } @if (menuItem().stringIcon) {
  <div class="bg-light-orange px-1 py-px rounded-full flex items-center">
    <span class="text-[0.625rem] text-light-white">{{
      menuItem().stringIcon
    }}</span>
  </div>
  }
</div>
